








import Vue from 'vue'
import { SearchParams } from '@/core/Facilities'

export default Vue.extend({
  name: 'MapView',
  components: {},
  props: {
    params: {
      type: Object as () => SearchParams,
      required: true,
    },
  },
  watch: {
    '$breakpoints.size'() {
      this.setViewMode()
    },
    params() {
      this.setParams()
    },
  },
  async created() {
    this.setVh()
    window.addEventListener('resize', this.setVh)

    // Map Viewのiframeから発行されるイベントを購読する
    this.listenToMapEvents()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVh)

    // Map Viewのイベントリスナを破棄する
    this.removeMapEventListeners()
  },
  methods: {
    setVh() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    },
    sendEvent(type: string, payload: any) {
      const map: HTMLIFrameElement | undefined = this.$refs.map as any
      if (!map) return
      map.contentWindow?.postMessage({ type, payload }, window.location.origin)
    },
    setViewMode() {
      if (this.$breakpoints.lg) {
        this.sendEvent('setViewMode', { viewMode: 'pc' })
      } else {
        this.sendEvent('setViewMode', { viewMode: 'sp' })
      }
    },
    setParams() {
      this.sendEvent('setConditions', { conditions: this.params })
    },
    listenToMapEvents() {
      this.onUpdateCountEvent = this.onUpdateCountEvent.bind(this)
      this.onListView = this.onListView.bind(this)
      this.onChangeConditions = this.onChangeConditions.bind(this)

      document.addEventListener('ready', this.onReady, false)
      document.addEventListener('updateCount', this.onUpdateCountEvent, false)
      document.addEventListener('listView', this.onListView, false)
      document.addEventListener(
        'changeConditions',
        this.onChangeConditions,
        false
      )
    },
    removeMapEventListeners() {
      document.removeEventListener(
        'updateCount',
        this.onUpdateCountEvent,
        false
      )
      document.removeEventListener('listView', this.onListView, false)
      document.removeEventListener(
        'changeConditions',
        this.onChangeConditions,
        false
      )
    },
    onReady() {
      this.setViewMode()
      this.setParams()
    },
    onUpdateCountEvent() {
      this.$emit('updateCount')
    },
    onListView() {
      this.$emit('listView')
    },
    onChangeConditions() {
      this.$emit('changeConditions')
    },
  },
})
